import { Backdrop, Location, Sound } from "./script.service";

export const debug_universal_locations: Location[] = [
  {
    id: 7,
    name: 'Backstage',
    img_url: 'https://via.placeholder.com/150'
  },
  {
    id: 8,
    name: 'Center Stage',
    img_url: 'https://via.placeholder.com/150'
  },
  {
    id: 9,
    name: 'Stage Left',
    img_url: 'https://via.placeholder.com/150'
  },
  {
    id: 10,
    name: 'Stage Right',
    img_url: 'https://via.placeholder.com/150'
  },
  {
    id: 11,
    name: 'Narrator Podium',
    img_url: 'https://via.placeholder.com/150'
  },
  {
    id: 12,
    name: 'Entrance Stage Left',
    img_url: 'https://via.placeholder.com/150'
  },
  {
    id: 13,
    name: 'Entrance Stage Right',
    img_url: 'https://via.placeholder.com/150'
  }
];

export const debug_backdrops: Backdrop[] = [
  {
    id: 6,
    name: 'Living Room',
    img_url: '/assets/images/aa_editor/livingroom.webp',
    locations: [
      { id: 14, name: 'Couch', img_url: 'https://via.placeholder.com/150' },
      { id: 15, name: 'Front Door', img_url: 'https://via.placeholder.com/150' },
      { id: 16, name: 'Side Door', img_url: 'https://via.placeholder.com/150' },
      { id: 17, name: 'Kitchen', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 7,
    name: 'Forest',
    img_url: '/assets/images/aa_editor/forest.webp',
    locations: []
  },
  {
    id: 8,
    name: 'Campsite',
    img_url: '/assets/images/aa_editor/campsite.webp',
    locations: [
      { id: 49, name: 'Behind bushes', img_url: 'https://via.placeholder.com/150' },
      { id: 50, name: 'Rock chair', img_url: 'https://via.placeholder.com/150' },
      { id: 51, name: 'Log chair', img_url: 'https://via.placeholder.com/150' },
      { id: 52, name: 'Camping chair', img_url: 'https://via.placeholder.com/150' },
      { id: 53, name: 'Stump chair', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 9,
    name: 'Interrogation Room',
    img_url: '/assets/images/aa_editor/interrogation_room.webp',
    locations: [
      { id: 18, name: 'Chair', img_url: 'https://via.placeholder.com/150' },
      { id: 19, name: 'Behind Door', img_url: 'https://via.placeholder.com/150' },
      { id: 20, name: 'Corner Left', img_url: 'https://via.placeholder.com/150' },
      { id: 21, name: 'Corner Right', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 10,
    name: 'Courtroom',
    img_url: '/assets/images/aa_editor/courtroom.webp',
    locations: [
      { id: 22, name: 'Judge Chair', img_url: 'https://via.placeholder.com/150' },
      { id: 23, name: 'Plaintiff Door', img_url: 'https://via.placeholder.com/150' },
      { id: 24, name: 'Plaintiff Table', img_url: 'https://via.placeholder.com/150' },
      { id: 25, name: 'Defendant Table', img_url: 'https://via.placeholder.com/150' },
      { id: 26, name: 'Defendant Door', img_url: 'https://via.placeholder.com/150' },
      { id: 27, name: 'Bailiff Corner', img_url: 'https://via.placeholder.com/150' },
      { id: 28, name: 'Witness Stand', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 11,
    name: 'Doctor\'s Office',
    img_url: '/assets/images/aa_editor/doctors_office.webp',
    locations: [
      { id: 31, name: 'Desk', img_url: 'https://via.placeholder.com/150' },
      { id: 32, name: 'Examination Table', img_url: 'https://via.placeholder.com/150' },
      { id: 76, name: 'Stool', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 12,
    name: 'Conference Room',
    img_url: '/assets/images/aa_editor/conference_room.webp',
    locations: [
      { id: 36, name: 'Boss Chair', img_url: 'https://via.placeholder.com/150' },
      { id: 37, name: 'Office Chair 1', img_url: 'https://via.placeholder.com/150' },
      { id: 38, name: 'Office Chair 2', img_url: 'https://via.placeholder.com/150' },
      { id: 39, name: 'Office Chair 3', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 13,
    name: 'Grocery Store',
    img_url: '/assets/images/aa_editor/grocery_store.webp',
    locations: [
      { id: 40, name: 'Behind Shelf', img_url: 'https://via.placeholder.com/150' },
      { id: 41, name: 'Behind Register', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 14,
    name: 'Hardware Store',
    img_url: '/assets/images/aa_editor/hardware_store.webp',
    locations: [
      { id: 43, name: 'Behind Register', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 15,
    name: 'Infomercial Kitchen',
    img_url: '/assets/images/aa_editor/infomercial_kitchen.webp',
    locations: []
  },
  {
    id: 16,
    name: 'Infomercial Bathroom',
    img_url: '/assets/images/aa_editor/infomercial_bathroom.webp',
    locations: [
      { id: 45, name: 'Toilet', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 17,
    name: 'Game Show',
    img_url: '/assets/images/aa_editor/game_show.webp',
    locations: [
      { id: 46, name: 'Host Podium', img_url: 'https://via.placeholder.com/150' },
      { id: 47, name: 'Contestant Podium 1', img_url: 'https://via.placeholder.com/150' },
      { id: 48, name: 'Contestant Podium 2', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 18,
    name: 'Forest Bridge',
    img_url: '/assets/images/aa_editor/forest_bridge.webp',
    locations: [
      { id: 54, name: 'On bridge', img_url: 'https://via.placeholder.com/150' },
      { id: 55, name: 'In river', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 19,
    name: 'Detective Noir',
    img_url: '/assets/images/aa_editor/detective_noir.webp',
    locations: [
      { id: 58, name: 'Visitor Chair', img_url: 'https://via.placeholder.com/150' },
      { id: 67, name: 'Detective Chair', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 20,
    name: 'Political Debate USA',
    img_url: '/assets/images/aa_editor/political_debate_usa.webp',
    locations: [
      { id: 33, name: 'Podium Stage Left', img_url: 'https://via.placeholder.com/150' },
      { id: 34, name: 'Podium Stage Right', img_url: 'https://via.placeholder.com/150' },
      { id: 35, name: 'Moderator Table', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 21,
    name: 'Backyard',
    img_url: '/assets/images/aa_editor/backyard.webp',
    locations: [
      { id: 60, name: 'Grill', img_url: 'https://via.placeholder.com/150' },
      { id: 61, name: 'Neighbor\'s yard', img_url: 'https://via.placeholder.com/150' },
      { id: 62, name: 'Sandbox', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 22,
    name: 'Dining Room',
    img_url: '/assets/images/aa_editor/dining_room.webp',
    locations: [
      { id: 63, name: 'Chair 1', img_url: 'https://via.placeholder.com/150' },
      { id: 64, name: 'Chair 2', img_url: 'https://via.placeholder.com/150' },
      { id: 65, name: 'Chair 3', img_url: 'https://via.placeholder.com/150' },
      { id: 66, name: 'Chair 4', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 23,
    name: 'Classroom',
    img_url: '/assets/images/aa_editor/classroom.png',
    locations: [
      { id: 68, name: 'Desk 1', img_url: 'https://via.placeholder.com/150' },
      { id: 69, name: 'Desk 2', img_url: 'https://via.placeholder.com/150' },
      { id: 70, name: 'Desk 3', img_url: 'https://via.placeholder.com/150' },
      { id: 71, name: 'Desk 4', img_url: 'https://via.placeholder.com/150' },
      { id: 72, name: 'Desk 5', img_url: 'https://via.placeholder.com/150' },
      { id: 73, name: 'Teacher Desk', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 24,
    name: 'News',
    img_url: '/assets/images/aa_editor/news.webp',
    locations: [
      { id: 74, name: 'News Desk', img_url: 'https://via.placeholder.com/150' },
      { id: 75, name: 'Fake Street Backdrop', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 25,
    name: 'Murder',
    img_url: 'assets/images/aa_editor/murder.webp',
    locations: []
  },
  {
    id: 26,
    name: 'City',
    img_url: 'assets/images/aa_editor/city.webp',
    locations: [
      { id: 78, name: 'Alley', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 27,
    name: 'Restaurant',
    img_url: 'assets/images/aa_editor/restaurant.webp',
    locations: [
      { id: 79, name: 'Chair 1', img_url: 'https://via.placeholder.com/150' },
      { id: 80, name: 'Chair 2', img_url: 'https://via.placeholder.com/150' }
    ]
  },
  {
    id: 28,
    name: 'Western',
    img_url: 'assets/images/aa_editor/western.webp',
    locations: [
      { id: 77, name: 'Balcony', img_url: 'https://via.placeholder.com/150' }
    ]
  }
];

export const debug_sounds: Sound[] = [
  { id: 1, name: '70s music', url: '656e3c0ac0f1c_70s music SAMPLE.ogg' },
  { id: 2, name: 'accordion sting', url: '656e3c120dcb6_accordion sting.ogg' },
  { id: 3, name: 'alien siren', url: '656e3bf0362ff_alien siren.ogg' },
  { id: 4, name: 'alien teleport', url: '656e3bf3c10c6_alien teleport.ogg' },
  { id: 5, name: 'anime sword gleam 1', url: '656d3db25ccee_anime sword gleam 1.ogg' },
  { id: 6, name: 'anime sword gleam 2', url: '656d3dc1230d5_anime sword gleam 2.ogg' },
  { id: 7, name: 'anime sword gleam 3', url: '656d3dc616596_anime sword gleam 3.ogg' },
  { id: 8, name: 'applause', url: '656d3def6d836_applause.ogg' },
  { id: 9, name: 'australian music 1', url: '656e3c189694e_australian music 1 SAMPLE.ogg' },
  { id: 10, name: 'aww', url: '656d3e0131c4f_aww.ogg' },
  { id: 11, name: 'badass music 1', url: '656e3c1fe4c32_badass music 1 SAMPLE.ogg' },
  { id: 12, name: 'bard music', url: '656e3c2b88700_bard music SAMPLE.ogg' },
  { id: 13, name: 'bard music 2', url: '656e3c2860e35_bard music 2 SAMPLE.ogg' },
  { id: 14, name: 'bird screech', url: '6601f8c5dfa90_bird screech.ogg' },
  { id: 15, name: 'bluegrass music', url: '656e3c321759b_bluegrass music SAMPLE.ogg' },
  { id: 16, name: 'break down door', url: '656d3e0b5c989_break down door.ogg' },
  { id: 17, name: 'canada anthem music', url: '656e3c48126e2_canada anthem music.ogg' },
  { id: 18, name: 'cellphone vibrate', url: '656d3e063fbce_cellphone vibrate.ogg' },
  { id: 19, name: 'chainsaw', url: '6601f8bb7cd54_chainsaw.ogg' },
  { id: 20, name: 'christmas music 1', url: '6584ab2987b59_christmas music 1 SAMPLE.ogg' },
  { id: 21, name: 'christmas music 2', url: '6584ab31a2ebe_christmas music 2 SAMPLE.ogg' },
  { id: 22, name: 'christmas music 3', url: '6584ab34c4f77_christmas music 3 SAMPLE.ogg' },
  { id: 23, name: 'church bell', url: '656e32cee9fbb_church bell.ogg' },
  { id: 24, name: 'corporate guitar music', url: '656e3c4e9b901_corporate guitar music SAMPLE.ogg' },
  { id: 25, name: 'corporate motivational music', url: '656e3c551afa5_corporate motivational music SAMPLE.ogg' },
  { id: 26, name: 'courtroom music', url: '656e3c5a959b8_courtroom music SAMPLE.ogg' },
  { id: 27, name: 'courtroom sting', url: '656e3c620f661_courtroom sting.ogg' },
  { id: 28, name: 'crashing debris', url: '656e59659c0a1_crashing debris.ogg' },
  { id: 29, name: 'crowd woo', url: '6601f879edcd5_crowd woo.ogg' },
  { id: 30, name: 'dark classical music', url: '6601f941e97c9_dark classical music SAMPLE.ogg' },
  { id: 31, name: 'discord notification', url: '656e32e10f4dd_discord notification.ogg' },
  { id: 32, name: 'door creak', url: '6601f8c08c712_door creak.ogg' },
  { id: 33, name: 'doorbell', url: '656e32e7454ec_doorbell.ogg' },
  { id: 34, name: 'double bass music', url: '656e3c67aae88_double bass music SAMPLE.ogg' },
  { id: 35, name: 'draw sword', url: '656e32ec9c54a_draw sword.ogg' },
  { id: 36, name: 'emotional piano music', url: '6584aaf26a0a1_emotional piano music SAMPLE.ogg' },
  { id: 37, name: 'epic cinematic music', url: '656e3c6f7490d_epic cinematic music SAMPLE.ogg' },
  { id: 38, name: 'epic fantasy music 1', url: '656e3c76423ae_epic fantasy music 1 SAMPLE.ogg' },
  { id: 39, name: 'epic fantasy music 2', url: '656e3c79d6c42_epic fantasy music 2 SAMPLE.ogg' },
  { id: 40, name: 'epic fantasy music 3', url: '656e3c7d33c19_epic fantasy music 3 SAMPLE.ogg' },
  { id: 41, name: 'explosion', url: '656e32f1a1567_explosion.ogg' },
  { id: 42, name: 'extreme knocking', url: '656e32f8f265f_extreme knocking.ogg' },
  { id: 43, name: 'fantasy music 2', url: '656e3c8345f4a_fantasy music 2 SAMPLE.ogg' },
  { id: 44, name: 'fire alarm', url: '656e33021d17a_fire alarm.ogg' },
  { id: 45, name: 'fistfight', url: '6601f8aaae484_fistfight.ogg' },
  { id: 46, name: 'footsteps on wood', url: '6601f8b6a2b09_footsteps on wood.ogg' },
  { id: 47, name: 'forest footstep', url: '656e3308482f0_forest footstep.ogg' },
  { id: 48, name: 'fortnite', url: '656e330e42346_fortnite.ogg' },
  { id: 49, name: 'french music', url: '6601f90db30f6_french music SAMPLE.ogg' },
  { id: 50, name: 'gameshow bonus round', url: '656e331544ca7_gameshow bonus round.ogg' },
  { id: 51, name: 'gameshow buzzer', url: '656e331b77c51_gameshow buzzer.ogg' },
  { id: 52, name: 'gameshow crowd shouting numbers', url: '656e33265a2ce_gameshow crowd shouting numbers.ogg' },
  { id: 53, name: 'gameshow ding', url: '656e332aa63ed_gameshow ding.ogg' },
  { id: 54, name: 'gameshow intro', url: '656e3c8c6d5b4_gameshow intro.ogg' },
  { id: 55, name: 'gameshow outro', url: '656e3c9110942_gameshow outro.ogg' },
  { id: 56, name: 'gameshow ring', url: '656e33316aa78_gameshow ring.ogg' },
  { id: 57, name: 'gameshow start', url: '656e3335321ba_gameshow start.ogg' },
  { id: 58, name: 'gameshow time expire', url: '656e333abda44_gameshow time expire.ogg' },
  { id: 59, name: 'gameshow timer music', url: '656e3341659b2_gameshow timer music.ogg' },
  { id: 60, name: 'gong', url: '656e33465e591_gong.ogg' },
  { id: 61, name: 'groose music', url: '656e3c9dc75ed_groose music SAMPLE.ogg' },
  { id: 62, name: 'guitar music 1', url: '656e3ca631420_guitar music 1 SAMPLE.ogg' },
  { id: 63, name: 'gunshot', url: '656e39cfe34ef_gunshot.ogg' },
  { id: 64, name: 'halloween music', url: '656e3cab9aef4_halloween music SAMPLE.ogg' },
  { id: 65, name: 'happy music 1', url: '656e3cb1be965_happy music 1 SAMPLE.ogg' },
  { id: 66, name: 'heavy door knocking', url: '656e39db3032f_heavy door knocking.ogg' },
  { id: 67, name: 'honking', url: '6601f89ada294_honking.ogg' },
  { id: 68, name: 'infomercial disclaimer', url: '656e39e21dfaf_infomercial disclaimer.ogg' },
  { id: 69, name: 'japanese music 1', url: '656e3cb81537c_japanese music 1 SAMPLE.ogg' },
  { id: 70, name: 'japanese music 2', url: '656e3cbbc75e4_japanese music 2 SAMPLE.ogg' },
  { id: 71, name: 'jazz music 1', url: '656e3cc29539c_jazz music 1 SAMPLE.ogg' },
  { id: 72, name: 'jazz music 2', url: '656e3cc60a9f8_jazz music 2 SAMPLE.ogg' },
  { id: 73, name: 'knife wound', url: '656e39e800cd0_knife wound.ogg' },
  { id: 74, name: 'knocking on door', url: '656e39ed70c29_knocking on door.ogg' },
  { id: 75, name: 'lacrimosa music', url: '656e3ccc40a1d_lacrimosa music SAMPLE.ogg' },
  { id: 76, name: 'laughter', url: '656e39f525fc9_laughter.ogg' },
  { id: 77, name: 'magic sound', url: '656e39faeba01_magic sound.ogg' },
  { id: 78, name: 'message receive', url: '656e3a03ef671_message receive.ogg' },
  { id: 79, name: 'message send', url: '656e3a0973751_message send.ogg' },
  { id: 80, name: 'mystery music 1', url: '6601f94f488bc_mystery music 1 SAMPLE.ogg' },
  { id: 81, name: 'noir music 1', url: '656e3cd9f4103_noir music 1 SAMPLE.ogg' },
  { id: 82, name: 'noir music 2', url: '656e3cdd9353d_noir music 2 SAMPLE.ogg' },
  { id: 83, name: 'noir music 3', url: '656e3ce11ed3a_noir music 3 SAMPLE.ogg' },
  { id: 84, name: 'noir music 4', url: '656e3ce485397_noir music 4 SAMPLE.ogg' },
  { id: 85, name: 'oldschool hiphop music', url: '6601f915efcf9_oldschool hiphop music SAMPLE.ogg' },
  { id: 86, name: 'peaceful fantasy music', url: '656e3cebab007_peaceful fantasy music SAMPLE.ogg' },
  { id: 87, name: 'piano theme', url: '6601f88cbdf25_piano theme.ogg' },
  { id: 88, name: 'pokemon battle music', url: '656e3cf2d591a_pokemon battle music SAMPLE.ogg' },
  { id: 89, name: 'pokemon battle start', url: '656e3cfa2dc02_pokemon battle start.ogg' },
  { id: 90, name: 'police car', url: '6601f8a600cbe_police car.ogg' },
  { id: 91, name: 'raygun shot', url: '656e3a156c446_raygun shot.ogg' },
  { id: 92, name: 'record scratch', url: '6601f8cb681d1_record scratch.ogg' },
  { id: 93, name: 'sad chug jug music', url: '656e3d01baf65_sad chug jug music SAMPLE.ogg' },
  { id: 94, name: 'scary music', url: '6584aaeaf25a4_scary music SAMPLE.ogg' },
  { id: 95, name: 'school bell', url: '656e3a19cb5b9_school bell.ogg' },
  { id: 96, name: 'scifi contraption', url: '6601f8840a934_scifi contraption.ogg' },
  { id: 97, name: 'scribbling', url: '6601f8af5417e_scribbling.ogg' },
  { id: 98, name: 'shark tank deal', url: '656e3d08c9fc0_shark tank deal.ogg' },
  { id: 99, name: 'shark tank discussion music 1', url: '656e3d0fd3a80_shark tank discussion music 1 SAMPLE.ogg' },
  { id: 100, name: 'shark tank offer', url: '656e3d149ae27_shark tank offer.ogg' },
  { id: 101, name: 'shark tank positive music', url: '656e3d1b0294a_shark tank positive music SAMPLE.ogg' },
  { id: 102, name: 'shark tank serious music 1', url: '656e3d21e0d6e_shark tank serious music 1 SAMPLE.ogg' },
  { id: 103, name: 'shark tank walking theme', url: '656e3d29e0bdc_shark tank walking theme.ogg' },
  { id: 104, name: 'silly music 1', url: '656e3d300f349_silly music 1 SAMPLE.ogg' },
  { id: 105, name: 'silly music 2', url: '656e3d34421f4_silly music 2 SAMPLE.ogg' },
  { id: 106, name: 'snipping', url: '6601f8d0cd14d_snipping.ogg' },
  { id: 107, name: 'spy ending sting', url: '656e3d3a99b55_spy ending sting.ogg' },
  { id: 108, name: 'spy machinery', url: '656e3a1eda57e_spy machinery.ogg' },
  { id: 109, name: 'spy music 1', url: '656e3d400f34e_spy music 1 SAMPLE.ogg' },
  { id: 110, name: 'spy music 2', url: '656e3d43e4b34_spy music 2 SAMPLE.ogg' },
  { id: 111, name: 'super epic charge up', url: '656e3a2583fdc_super epic charge up.ogg' },
  { id: 112, name: 'superhero fanfare', url: '6601f90742963_superhero fanfare.ogg' },
  { id: 113, name: 'superhero music', url: '6601f91cac9b7_superhero music SAMPLE.ogg' },
  { id: 114, name: 'sword fighting', url: '656e3a2ac3b76_sword fighting.ogg' },
  { id: 115, name: 'tada', url: '656e3a308c0ff_tada.ogg' },
  { id: 116, name: 'telenovela music 1', url: '656e3d4a19a08_telenovela music 1 SAMPLE.ogg' },
  { id: 117, name: 'telenovela music 2', url: '656e3d4d71673_telenovela music 2 SAMPLE.ogg' },
  { id: 118, name: 'telenovela music 3', url: '6584ab1dc0e86_telenovela music 3 SAMPLE.ogg' },
  { id: 119, name: 'telenovela sting 1', url: '656e3d54239d4_telenovela sting 1.ogg' },
  { id: 120, name: 'telenovela sting 2', url: '656e3d57845ce_telenovela sting 2.ogg' },
  { id: 121, name: 'tense cinematic music', url: '656e3d5d853ac_tense cinematic music SAMPLE.ogg' },
  { id: 122, name: 'thunder', url: '656e3a345a16c_thunder.ogg' },
  { id: 123, name: 'tire screech', url: '6601f8a07faa6_tire screech.ogg' },
  { id: 124, name: 'usa anthem music', url: '656e3d6378133_usa anthem music.ogg' },
  { id: 125, name: 'ussr anthem music', url: '656e3d680b577_ussr anthem music.ogg' },
  { id: 126, name: 'vine boom', url: '656e3a3885a29_vine boom.ogg' },
  { id: 127, name: 'waltz music', url: '6601f948aa9c3_waltz music SAMPLE.ogg' },
  { id: 128, name: 'waterphone', url: '656e3a3cf2ade_waterphone.ogg' },
  { id: 129, name: 'western hero theme', url: '6601f9337d41a_western hero theme SAMPLE.ogg' },
  { id: 130, name: 'western jingle 1', url: '656e3d6e0302d_western jingle 1.ogg' },
  { id: 131, name: 'western piano music 1', url: '6601f92b5981d_western piano music 1 SAMPLE.ogg' },
  { id: 132, name: 'western piano music 2', url: '6601f92730d96_western piano music 2 SAMPLE.ogg' },
  { id: 133, name: 'western showdown music', url: '6601f93a517b0_western showdown music SAMPLE.ogg' },
  { id: 134, name: 'world news intro', url: '656e3d72d0e51_world news intro.ogg' },
  { id: 135, name: 'world news outro', url: '656e3d7853db4_world news outro.ogg' },
  { id: 136, name: 'yankee doodle music', url: '656e3d7f3c1d9_yankee doodle music SAMPLE.ogg' }
];